import { createFileRoute } from '@tanstack/react-router';
import { Footer, MarketingHeader, SEO } from '@/components';
import { AppCostCalculator } from '@/components/pricing/AppCostCalculator';

const PATH = '/coparenting-app-cost-calculator';

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: 'https://harborcoparent.com/',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Co-parenting app cost calculator',
      item: `https://harborcoparent.com${PATH}`,
    },
  ],
};

const appJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'Co-Parenting App Cost Calculator',
  applicationCategory: 'FinanceApplication',
  operatingSystem: 'Web',
  description:
    'Estimate what Harbor, OurFamilyWizard, TalkingParents, AppClose, 2houses, and Custody X Change cost over one to five years.',
  url: `https://harborcoparent.com${PATH}`,
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
};

function CostCalculatorPage() {
  return (
    <div className='min-h-screen bg-white'>
      <SEO
        title='Co-Parenting App Cost Calculator (2026): Compare 1–5 Year Costs | Harbor'
        description='Estimate what Harbor, OurFamilyWizard, TalkingParents, AppClose, 2houses, and Custody X Change cost over one to five years. Compare per-parent and household pricing, see ranges, and compare the modeled plans.'
        path={PATH}
      />
      {[appJsonLd, breadcrumbJsonLd].map((data, index) => (
        <script
          key={index}
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(data).replace(/</g, '\\u003c'),
          }}
        />
      ))}
      <div className='print:hidden'>
        <MarketingHeader />
      </div>

      <section className='bg-primary/5 pt-32 pb-12'>
        <div className='mx-auto max-w-4xl px-6 text-center'>
          <h1 className='text-4xl font-bold text-gray-900 md:text-5xl'>
            Co-parenting App Cost Calculator
          </h1>
        </div>
      </section>

      <main className='mx-auto max-w-7xl px-6 py-12'>
        <AppCostCalculator />
      </main>

      <Footer />
    </div>
  );
}

export const Route = createFileRoute('/coparenting-app-cost-calculator')({
  component: CostCalculatorPage,
});
